import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./CreateNewAccountModal.module.css";
import ModalActionBar from "shared/ModalActionBar";
import { Modal } from "shared/Modal";
import SearchBar from "DreamStream/Shared/SearchBar";
import InputItem from "DreamStream/Shared/InputItem";
import CheckBoxItem from "DreamStream/Shared/CheckBoxItem";
import classNames from "classnames";

/*
 * Interactive component. Modal used for creating a new account.
 */

export function CreateNewAccountModal({ isOpen, onClose, userInfo }) {
  const [ibo, setIbo] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [altEmail, setAltEmail] = useState("");
  const [sendInvite, setSendInvite] = useState(false);
  const [customId, setCustomId] = useState("");
  const [errors, setErrors] = useState({});

  const isEmail = (email) =>
    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

  const validate = () => {
    const _errors = {};
    if (!isEmail(altEmail)) {
      _errors.email = "Please enter valid email";
    } else {
      alert("Create Account");
    }
    setErrors(_errors);
  };

  const [_userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    setUserInfo(null);
    if (ibo.length > 0) {
      const _userInfo = userInfo.find(
        (user) => user.iboNumber === parseInt(ibo)
      );
      if (_userInfo) {
        setUserInfo(_userInfo);
      }
    }
  }, [ibo, userInfo]);

  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="CREATE ACCOUNT"
        closeBtn="none"
        className={styles.modal}
      >
        <div className={styles.infoTextDiv}>
          <p className={styles.text}>
            Create a new Dreamstream account for an active Premier member.
          </p>
        </div>

        <div className={styles.searchDiv}>
          <SearchBar
            placeholderText="Search by IBO#"
            searchDelay={0}
            minChar={0}
            btn={false}
            value={ibo}
            onInput={(value) => setIbo(value)}
            className={styles.searchbar}
          />
        </div>
        <div className={styles.infoContainer}>
          <div className={styles.infoDiv}>
            <p className={styles.label}>Name:</p>
            <p className={styles.description}>
              {_userInfo && _userInfo.iboInfo.name
                ? _userInfo.iboInfo.name
                : ""}
            </p>
          </div>
          <div className={styles.infoDiv}>
            <p className={styles.label}>IBO #:</p>
            <p className={styles.description}>
              {_userInfo && _userInfo.iboNumber ? _userInfo.iboNumber : ""}
            </p>
          </div>
          <div className={styles.infoDiv}>
            <p className={styles.label}>WWG Email:</p>
            <p className={styles.description}>
              {_userInfo && _userInfo.iboInfo.email
                ? _userInfo.iboInfo.email
                : ""}
            </p>
          </div>
        </div>
        <div className={styles.hr} />

        <form onSubmit={() => {}}>
          <div className={styles.optionalDiv}>
            <p className={styles.optional}>Optional</p>
            <div className={styles.inputContainer}>
              <div className={styles.inputDiv}>
                <label htmlFor={displayName} className={styles.label}>
                  Display Name:
                </label>
                <InputItem
                  value={displayName}
                  placeholder={"Click to type"}
                  onChange={(e) => {
                    setDisplayName(e.target.value);
                  }}
                />
              </div>
              <div className={styles.inputDiv}>
                <label htmlFor={altEmail} className={styles.label}>
                  Alternative Email:{" "}
                  {errors.email ? <span className={styles.error}>*</span> : ""}
                </label>
                <InputItem
                  value={altEmail}
                  placeholder={"Click to type"}
                  onChange={(e) => {
                    setAltEmail(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className={styles.checkbox}>
              <label htmlFor="add-as" className={styles.label}></label>
              <CheckBoxItem
                name="Send invite email to alternative email address"
                checked={sendInvite}
                onClick={() => setSendInvite(!sendInvite)}
              />
            </div>

            <div className={styles.inputDiv}>
              <label htmlFor={displayName} className={styles.label}>
                Custom Ext-Id:
              </label>
              <InputItem
                value={customId}
                placeholder={"Click to type"}
                onChange={(e) => {
                  setCustomId(e.target.value);
                }}
              />
            </div>
          </div>

          <div className={styles.btnContainer}>
            <ModalActionBar
              children={
                <div className={styles.btnDiv}>
                  <button
                    type="button"
                    className={styles.cancelBtn}
                    onClick={onClose}
                  >
                    CANCEL
                  </button>
                  <button
                    disabled={
                      _userInfo && !_userInfo.isActive && !_userInfo.wwgId
                    }
                    type="button"
                    className={styles.createBtn}
                    onClick={() => {
                      validate();
                    }}
                  >
                    CREATE USER
                  </button>
                </div>
              }
            />
          </div>
        </form>
      </Modal>
    </div>
  );
}

CreateNewAccountModal.propTypes = {
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * 	Object with the users info
   */
  userInfo: PropTypes.shape({
    name: PropTypes.string,
    iboNum: PropTypes.string,
    wwgEmail: PropTypes.string,
  }),
};
